'use es6';

import { memo } from 'react';
import DashedLabel from '../../atoms/DashedLabel';
import { getSimpleDateText } from 'conversations-message-history/util/getSimpleDateText';
import { getTimestamp } from 'conversations-message-history/dates/operators/getters';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { jsx as _jsx } from "react/jsx-runtime";
const ShortDateLabel = /*#__PURE__*/memo(({
  message
}) => {
  const timestamp = getTimestamp(message);
  return /*#__PURE__*/_jsx(DashedLabel, {
    "data-test-vr-hidden": true,
    children: getSimpleDateText(timestamp)
  });
});
ShortDateLabel.displayName = 'ShortDateLabel';
ShortDateLabel.propTypes = {
  message: RecordPropType('DateMessage').isRequired
};
export default ShortDateLabel;